import { Stack, Typography } from '@mui/material';
import { BlurredBox } from 'modules/common/components/BlurredBox';
import { useBreakpoints } from 'modules/common/hooks/useBreakpoints';
import { ReactNode } from 'react';

interface IInfoBlockProps {
  left: ReactNode;
  title: ReactNode;
  description: ReactNode;
}

export function InfoBlock({
  left,
  title,
  description,
}: IInfoBlockProps): JSX.Element {
  const { isSmDown } = useBreakpoints();

  return (
    <BlurredBox
      sx={{
        padding: 2,
        borderRadius: 1.2,
        fontWeight: 'bold',
        width: '100%',
      }}
    >
      <Stack
        alignItems="flex-start"
        gap={isSmDown ? 1.5 : 2.5}
        sx={{
          alignItems: { xs: 'flex-start', sm: 'center' },
        }}
      >
        {left}

        <Stack gap={1} width="100%">
          <Typography
            variant="body2"
            fontSize={isSmDown ? 16 : 18}
            fontWeight={500}
          >
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </Stack>
      </Stack>
    </BlurredBox>
  );
}
